import './Content.css';
import React, { Component, useEffect } from 'react';

import { connect, useSelector } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import AudienceBuilderAnalytics from 'components/pages/analytics/Analytics'; // TODO: Change path
import AudienceBuilderImport from 'components/pages/AudienceBuilder/BulkImport/';
import AudienceBuilderCampaigns from 'components/pages/AudienceBuilder/Campaigns';
import AudienceBuilderRedirectCreator from 'components/pages/AudienceBuilder/Campaigns/RedirectCreator';
import AudienceBuilderSettings from 'components/pages/AudienceBuilder/Settings';
import ErrorPaiementModal from 'components/pages/billing/ErrorPaiementModal/ErrorPaiementModal';
import Invoices from 'components/pages/billing/Invoices';
import UsagePage from 'components/pages/billing/UsagePage/UsagePage';
import { SearchButton } from 'components/pages/redirects/SearchButton';
import { s, sn } from 'lib/safe';
import { loadCard, setDefaultCard } from 'stores/subscription';

import { CampaignBreadCrumb } from './CampaignBreadCrumb';

function AudienceBuilderContent({
  account,
  match,
  loadCard,
  setDefaultCard,
  history,
}: {
  account: accountT,
  match: Match,
  loadCard: ({ organizationId: string }) => void,
  setDefaultCard: ({ organizationId: string, setupIntent: string }) => void,
  history: { replace: ({ search: string }) => void },
}) {
  useEffect(() => {
    loadCard({ organizationId: account.organizationId });
  }, [account]);

  const queryParams = new URLSearchParams(location.search);

  if (queryParams.has('redirect_status')) {
    const status = queryParams.get('redirect_status');
    const setupIntent = queryParams.get('setup_intent');
    const errorMessage = queryParams.get('message');
    const errorCode = queryParams.get('code');

    queryParams.forEach((value, key) => {
      queryParams.delete(key);
    });

    history.replace({
      search: queryParams.toString(),
    });

    if (status === 'error') {
      console.error(`UBS Checkout Error ${errorCode}: ${errorMessage}`);
    } else if (status === 'succeeded' && setupIntent) {
      setDefaultCard({ organizationId: account.organizationId, setupIntent });
    }
  }

  const { needsCard } = useSelector((states) => {
    const planID = sn(states.subscription, 'sub.plan.id', '');

    return {
      needsCard: s(states.subscription.card).name === undefined && !planID.startsWith('lifetimedeal_'),
    };
  });

  return (
    <div className="content">
      <Switch>
        <Route
          path={`${match.url}/campaigns`}
          render={() => (
            <>
              <nav className="content__breadcrumb box">
                <CampaignBreadCrumb />
                <SearchButton />
                <AudienceBuilderRedirectCreator cardRegistered={!needsCard} />
                <ErrorPaiementModal />
              </nav>
              <AudienceBuilderCampaigns account={account} />
            </>
          )}
        />
        <Route
          path={`${match.url}/analytics/:entity?/:redirectId?`}
          render={(props) => <AudienceBuilderAnalytics account={account} match={props.match} />}
        />
        <Route path={`${match.url}/bulk-import`} render={() => <AudienceBuilderImport account={account} />} />
        <Route
          path={`${match.url}/settings`}
          render={() => <AudienceBuilderSettings account={account} match={match} />}
        />
        {/* Default redir */}
        <Redirect to={`${match.url}/campaigns`} />
      </Switch>
    </div>
  );
}

const AudienceBuilderContentC = withRouter(connect(null, { loadCard, setDefaultCard })(AudienceBuilderContent));

export { AudienceBuilderContentC as AudienceBuilderContent };

class BillingContent extends Component<{
  user: userT,
  account: accountT,
  sub: subscriptionT,
  match: Match,
}> {
  render() {
    const { user, account, sub, match } = this.props;

    if (sub === undefined) {
      return null;
    }

    return (
      <div className="content">
        <Switch>
          <Route path={`${match.url}/invoices`} render={() => <Invoices account={account} user={user} />} />

          <Route path={`${match.url}/usage`} render={() => <UsagePage></UsagePage>} />

          <Redirect to={`${match.url}/usage`} />
        </Switch>
      </div>
    );
  }
}

const mapBillingStateToProps = function (state): { card: cardT, plans: Array<planT>, updating: boolean } {
  const { plans, updating, sub } = state.subscription;
  const { user } = state.user;
  const { limitations } = state.accounts;

  return {
    sub,
    plans,
    updating,
    user,
    limitations,
  };
};

const BillingContentC = withRouter(connect(mapBillingStateToProps, {})(BillingContent));

export { BillingContentC as BillingContent };
